'use client'

import { GoogleAnalytics } from 'nextjs-google-analytics'
import { useRef } from 'react'

import { AuthProvider } from '@/helpers/firebase/auth/AuthProvider'
import { AnalyticsTracking } from '@/helpers/analytics/Analytics'

const LayoutNoCanvas = ({ children }) => {
  const ref = useRef()
  return (
    <AuthProvider needsAuth>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 10,
          overflow: 'hidden',
          backgroundColor: '#2d2d2d',
        }}
        ref={ref}
      >
        {children}
      </div>
      <GoogleAnalytics trackPageViews gaMeasurementId='G-G6TH0KKJWX' />
      <AnalyticsTracking />
    </AuthProvider>
  )
}

export { LayoutNoCanvas }
